export const AllJackpotChart =[
        {
            "resultDate": "12/30/2024",
            "results": [
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "04",
                     }
            ]
        },
        {
            "resultDate": "12/31/2024",
            "results": [
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "13",
                     }
            ]
        },
        {
            "resultDate": "01/01/2025",
            "results": [
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "42",
                     }
            ]
        },
        {
            "resultDate": "01/02/2025",
            "results": [
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "50",
                     }
            ]
        },
        {
            "resultDate": "01/03/2025",
            "results": [
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "48",
                     }
            ]
        },
        {
            "resultDate": "01/04/2025",
            "results": [
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "92",
                     }
            ]
        },
        {
            "resultDate": "01/05/2025",
            "results": [
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "62",
                     }
            ]
        },
        {
            "resultDate": "01/06/2025",
            "results": [
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "41",
                     }
            ]
        },
        {
            "resultDate": "01/07/2025",
            "results": [
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "77",
                     }
            ]
        },
        {
            "resultDate": "01/08/2025",
            "results": [
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "35",
                     }
            ]
        },
        {
            "resultDate": "01/09/2025",
            "results": [
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "19",
                     }
            ]
        },
        {
            "resultDate": "01/10/2025",
            "results": [
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "92",
                     }
            ]
        },
        {
            "resultDate": "01/11/2025",
            "results": [
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "04",
                     }
            ]
        },
        {
            "resultDate": "01/12/2025",
            "results": [
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "43",
                     }
            ]
        },
        {
            "resultDate": "01/13/2025",
            "results": [
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "72",
                     }
            ]
        },
        {
            "resultDate": "01/14/2025",
            "results": [
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "36",
                     }
            ]
        },
        {
            "resultDate": "01/15/2025",
            "results": [
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "90",
                     }
            ]
        },
        {
            "resultDate": "01/16/2025",
            "results": [
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "01",
                     }
            ]
        },
        {
            "resultDate": "01/17/2025",
            "results": [
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "48",
                     }
            ]
        },
        {
            "resultDate": "01/18/2025",
            "results": [
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "79",
                     }
            ]
        },
        {
            "resultDate": "01/19/2025",
            "results": [
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "05",
                     }
            ]
        },
        {
            "resultDate": "01/20/2025",
            "results": [
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "27",
                     }
            ]
        },
        {
            "resultDate": "01/21/2025",
            "results": [
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "75",
                     }
            ]
        },
        {
            "resultDate": "01/22/2025",
            "results": [
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "37",
                     }
            ]
        },
        {
            "resultDate": "01/23/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "87",
                     }
            ]
        },
        {
            "resultDate": "01/24/2025",
            "results": [
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "34",
                     }
            ]
        },
        {
            "resultDate": "01/25/2025",
            "results": [
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "61",
                     }
            ]
        },
        {
            "resultDate": "01/26/2025",
            "results": [
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "74",
                     }
            ]
        },
        {
            "resultDate": "01/27/2025",
            "results": [
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "43",
                     }
            ]
        },
        {
            "resultDate": "01/28/2025",
            "results": [
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "48",
                     }
            ]
        },
        {
            "resultDate": "01/29/2025",
            "results": [
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "96",
                     }
            ]
        },
        {
            "resultDate": "01/30/2025",
            "results": [
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "39",
                     }
            ]
        },
        {
            "resultDate": "01/31/2025",
            "results": [
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "71",
                     }
            ]
        },
        {
            "resultDate": "02/01/2025",
            "results": [
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "06",
                     }
            ]
        },
        {
            "resultDate": "02/02/2025",
            "results": [
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "56",
                     }
            ]
        },
        {
            "resultDate": "02/03/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "20",
                     }
            ]
        },
        {
            "resultDate": "02/04/2025",
            "results": [
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "81",
                     }
            ]
        },
        {
            "resultDate": "02/05/2025",
            "results": [
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "63",
                     }
            ]
        },
        {
            "resultDate": "02/06/2025",
            "results": [
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "23",
                     }
            ]
        },
        {
            "resultDate": "02/07/2025",
            "results": [
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "28",
                     }
            ]
        },
        {
            "resultDate": "02/08/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "98",
                     }
            ]
        },
        {
            "resultDate": "02/09/2025",
            "results": [
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "26",
                     }
            ]
        },
        {
            "resultDate": "02/10/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "86",
                     }
            ]
        },
        {
            "resultDate": "02/11/2025",
            "results": [
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "67",
                     }
            ]
        },
        {
            "resultDate": "02/12/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "56",
                     }
            ]
        },
        {
            "resultDate": "02/13/2025",
            "results": [
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "31",
                     }
            ]
        },
        {
            "resultDate": "02/14/2025",
            "results": [
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "81",
                     }
            ]
        },
        {
            "resultDate": "02/15/2025",
            "results": [
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "74",
                     }
            ]
        },
        {
            "resultDate": "02/16/2025",
            "results": [
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "78",
                     }
            ]
        },
        {
            "resultDate": "02/17/2025",
            "results": [
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "87",
                     }
            ]
        },
        {
            "resultDate": "02/18/2025",
            "results": [
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "42",
                     }
            ]
        },
        {
            "resultDate": "02/19/2025",
            "results": [
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "47",
                     }
            ]
        },
        {
            "resultDate": "02/20/2025",
            "results": [
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "74",
                     }
            ]
        },
        {
            "resultDate": "02/21/2025",
            "results": [
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "63",
                     }
            ]
        },
        {
            "resultDate": "02/22/2025",
            "results": [
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "15",
                     }
            ]
        },
        {
            "resultDate": "02/23/2025",
            "results": [
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "86",
                     }
            ]
        },
        {
            "resultDate": "02/24/2025",
            "results": [
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "91",
                     }
            ]
        },
        {
            "resultDate": "02/25/2025",
            "results": [
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "87",
                     }
            ]
        },
        {
            "resultDate": "02/26/2025",
            "results": [
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "09",
                     }
            ]
        },
        {
            "resultDate": "02/27/2025",
            "results": [
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "18",
                     }
            ]
        },
        {
            "resultDate": "02/28/2025",
            "results": [
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "76",
                     }
            ]
        },
        {
            "resultDate": "03/01/2025",
            "results": [
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "87",
                     }
            ]
        },
        {
            "resultDate": "03/02/2025",
            "results": [
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "49",
                     }
            ]
        },
        {
            "resultDate": "03/03/2025",
            "results": [
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "89",
                     }
            ]
        },
        {
            "resultDate": "03/04/2025",
            "results": [
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "76",
                     }
            ]
        },
        {
            "resultDate": "03/05/2025",
            "results": [
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "55",
                     }
            ]
        },
        {
            "resultDate": "03/06/2025",
            "results": [
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "79",
                     }
            ]
        },
        {
            "resultDate": "03/07/2025",
            "results": [
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "10",
                     }
            ]
        },
        {
            "resultDate": "03/08/2025",
            "results": [
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "49",
                     }
            ]
        },
        {
            "resultDate": "03/09/2025",
            "results": [
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "21",
                     }
            ]
        },
        {
            "resultDate": "03/10/2025",
            "results": [
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "74",
                     }
            ]
        },
        {
            "resultDate": "03/11/2025",
            "results": [
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "80",
                     }
            ]
        },
        {
            "resultDate": "03/12/2025",
            "results": [
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "84",
                     }
            ]
        },
        {
            "resultDate": "03/13/2025",
            "results": [
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "13",
                     }
            ]
        },
        {
            "resultDate": "03/14/2025",
            "results": [
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "28",
                     }
            ]
        },
        {
            "resultDate": "03/15/2025",
            "results": [
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "49",
                     }
            ]
        },
        {
            "resultDate": "03/16/2025",
            "results": [
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "21",
                     }
            ]
        },
        {
            "resultDate": "03/17/2025",
            "results": [
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "60",
                     }
            ]
        },
        {
            "resultDate": "03/18/2025",
            "results": [
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "12",
                     }
            ]
        },
        {
            "resultDate": "03/19/2025",
            "results": [
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "24",
                     }
            ]
        },
        {
            "resultDate": "03/20/2025",
            "results": [
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "82",
                     }
            ]
        },
        {
            "resultDate": "03/21/2025",
            "results": [
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "78",
                     }
            ]
        },
        {
            "resultDate": "03/22/2025",
            "results": [
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "12",
                     }
            ]
        },
        {
            "resultDate": "03/23/2025",
            "results": [
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "91",
                     }
            ]
        },
        {
            "resultDate": "03/24/2025",
            "results": [
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "02",
                     }
            ]
        },
        {
            "resultDate": "03/25/2025",
            "results": [
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "21",
                     }
            ]
        },
        {
            "resultDate": "03/26/2025",
            "results": [
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "40",
                     }
            ]
        },
        {
            "resultDate": "03/27/2025",
            "results": [
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "13",
                     }
            ]
        },
        {
            "resultDate": "03/28/2025",
            "results": [
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "68",
                     }
            ]
        },
        {
            "resultDate": "03/29/2025",
            "results": [
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "29",
                     }
            ]
        },
        {
            "resultDate": "03/30/2025",
            "results": [
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "64",
                     }
            ]
        },
        {
            "resultDate": "03/31/2025",
            "results": [
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "42",
                     }
            ]
        },
        {
            "resultDate": "04/01/2025",
            "results": [
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "35",
                     }
            ]
        },
        {
            "resultDate": "04/02/2025",
            "results": [
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "88",
                     }
            ]
        },
        {
            "resultDate": "04/03/2025",
            "results": [
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "92",
                     }
            ]
        },
        {
            "resultDate": "04/04/2025",
            "results": [
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "69",
                     }
            ]
        },
        {
            "resultDate": "04/05/2025",
            "results": [
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "85",
                     }
            ]
        },
        {
            "resultDate": "04/06/2025",
            "results": [
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "47",
                     }
            ]
        },
        {
            "resultDate": "04/07/2025",
            "results": [
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "01",
                     }
            ]
        },
        {
            "resultDate": "04/08/2025",
            "results": [
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "56",
                     }
            ]
        },
        {
            "resultDate": "04/09/2025",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "92",
                     }
            ]
        },
        {
            "resultDate": "04/10/2025",
            "results": [
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "49",
                     }
            ]
        },
        {
            "resultDate": "04/11/2025",
            "results": [
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "96",
                     }
            ]
        },
        {
            "resultDate": "04/12/2025",
            "results": [
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "14",
                     }
            ]
        },
        {
            "resultDate": "04/13/2025",
            "results": [
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "46",
                     }
            ]
        },
        {
            "resultDate": "04/14/2025",
            "results": [
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "73",
                     }
            ]
        },
        {
            "resultDate": "04/15/2025",
            "results": [
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "24",
                     }
            ]
        },
        {
            "resultDate": "04/16/2025",
            "results": [
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "36",
                     }
            ]
        },
        {
            "resultDate": "04/17/2025",
            "results": [
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "78",
                     }
            ]
        },
        {
            "resultDate": "04/18/2025",
            "results": [
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "92",
                     }
            ]
        },
        {
            "resultDate": "04/19/2025",
            "results": [
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "86",
                     }
            ]
        },
        {
            "resultDate": "04/20/2025",
            "results": [
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "42",
                     }
            ]
        },
        {
            "resultDate": "04/21/2025",
            "results": [
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "06",
                     }
            ]
        },
        {
            "resultDate": "04/22/2025",
            "results": [
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "40",
                     }
            ]
        },
        {
            "resultDate": "04/23/2025",
            "results": [
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "95",
                     }
            ]
        },
        {
            "resultDate": "04/24/2025",
            "results": [
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "37",
                     }
            ]
        },
        {
            "resultDate": "04/25/2025",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "04",
                     }
            ]
        },
        {
            "resultDate": "04/26/2025",
            "results": [
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "87",
                     }
            ]
        },
        {
            "resultDate": "04/27/2025",
            "results": [
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "16",
                     }
            ]
        },
        {
            "resultDate": "04/28/2025",
            "results": [
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "52",
                     }
            ]
        },
        {
            "resultDate": "04/29/2025",
            "results": [
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "19",
                     }
            ]
        },
        {
            "resultDate": "04/30/2025",
            "results": [
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "96",
                     }
            ]
        },
        {
            "resultDate": "05/01/2025",
            "results": [
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "62",
                     }
            ]
        },
        {
            "resultDate": "05/02/2025",
            "results": [
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "04",
                     }
            ]
        },
        {
            "resultDate": "05/03/2025",
            "results": [
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "18",
                     }
            ]
        },
        {
            "resultDate": "05/04/2025",
            "results": [
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "03",
                     }
            ]
        },
        {
            "resultDate": "05/05/2025",
            "results": [
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "81",
                     }
            ]
        },
        {
            "resultDate": "05/06/2025",
            "results": [
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "20",
                     }
            ]
        },
        {
            "resultDate": "05/07/2025",
            "results": [
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "35",
                     }
            ]
        },
        {
            "resultDate": "05/08/2025",
            "results": [
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "68",
                     }
            ]
        },
        {
            "resultDate": "05/09/2025",
            "results": [
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "91",
                     }
            ]
        },
        {
            "resultDate": "05/10/2025",
            "results": [
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "07",
                     }
            ]
        },
        {
            "resultDate": "05/11/2025",
            "results": [
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "52",
                     }
            ]
        },
        {
            "resultDate": "05/12/2025",
            "results": [
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "65",
                     }
            ]
        },
        {
            "resultDate": "05/13/2025",
            "results": [
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "56",
                     }
            ]
        },
        {
            "resultDate": "05/14/2025",
            "results": [
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "45",
                     }
            ]
        },
        {
            "resultDate": "05/15/2025",
            "results": [
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "18",
                     }
            ]
        },
        {
            "resultDate": "05/16/2025",
            "results": [
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "97",
                     }
            ]
        },
        {
            "resultDate": "05/17/2025",
            "results": [
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "57",
                     }
            ]
        },
        {
            "resultDate": "05/18/2025",
            "results": [
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "79",
                     }
            ]
        },
        {
            "resultDate": "05/19/2025",
            "results": [
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "04",
                     }
            ]
        },
        {
            "resultDate": "05/20/2025",
            "results": [
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "59",
                     }
            ]
        },
        {
            "resultDate": "05/21/2025",
            "results": [
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "23",
                     }
            ]
        },
        {
            "resultDate": "05/22/2025",
            "results": [
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "21",
                     }
            ]
        },
        {
            "resultDate": "05/23/2025",
            "results": [
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "78",
                     }
            ]
        },
        {
            "resultDate": "05/24/2025",
            "results": [
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "96",
                     }
            ]
        },
        {
            "resultDate": "05/25/2025",
            "results": [
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "03",
                     }
            ]
        },
        {
            "resultDate": "05/26/2025",
            "results": [
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "49",
                     }
            ]
        },
        {
            "resultDate": "05/27/2025",
            "results": [
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "38",
                     }
            ]
        },
        {
            "resultDate": "05/28/2025",
            "results": [
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "85",
                     }
            ]
        },
        {
            "resultDate": "05/29/2025",
            "results": [
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "16",
                     }
            ]
        },
        {
            "resultDate": "05/30/2025",
            "results": [
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "07",
                     }
            ]
        },
        {
            "resultDate": "05/31/2025",
            "results": [
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "06",
                     }
            ]
        },
        {
            "resultDate": "06/01/2025",
            "results": [
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "14",
                     }
            ]
        },
        {
            "resultDate": "06/02/2025",
            "results": [
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "03",
                     }
            ]
        },
        {
            "resultDate": "06/03/2025",
            "results": [
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "53",
                     }
            ]
        },
        {
            "resultDate": "06/04/2025",
            "results": [
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "75",
                     }
            ]
        },
        {
            "resultDate": "06/05/2025",
            "results": [
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "41",
                     }
            ]
        },
        {
            "resultDate": "06/06/2025",
            "results": [
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "02",
                     }
            ]
        },
        {
            "resultDate": "06/07/2025",
            "results": [
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "96",
                     }
            ]
        },
        {
            "resultDate": "06/08/2025",
            "results": [
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "14",
                     }
            ]
        },
        {
            "resultDate": "06/09/2025",
            "results": [
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "38",
                     }
            ]
        },
        {
            "resultDate": "06/10/2025",
            "results": [
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "45",
                     }
            ]
        },
        {
            "resultDate": "06/11/2025",
            "results": [
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "86",
                     }
            ]
        },
        {
            "resultDate": "06/12/2025",
            "results": [
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "81",
                     }
            ]
        },
        {
            "resultDate": "06/13/2025",
            "results": [
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "95",
                     }
            ]
        },
        {
            "resultDate": "06/14/2025",
            "results": [
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "23",
                     }
            ]
        },
        {
            "resultDate": "06/15/2025",
            "results": [
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "37",
                     }
            ]
        },
        {
            "resultDate": "06/16/2025",
            "results": [
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "97",
                     }
            ]
        },
        {
            "resultDate": "06/17/2025",
            "results": [
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "42",
                     }
            ]
        },
        {
            "resultDate": "06/18/2025",
            "results": [
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "59",
                     }
            ]
        },
        {
            "resultDate": "06/19/2025",
            "results": [
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "18",
                     }
            ]
        },
        {
            "resultDate": "06/20/2025",
            "results": [
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "73",
                     }
            ]
        },
        {
            "resultDate": "06/21/2025",
            "results": [
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "82",
                     }
            ]
        },
        {
            "resultDate": "06/22/2025",
            "results": [
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "12",
                     }
            ]
        },
        {
            "resultDate": "06/23/2025",
            "results": [
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "46",
                     }
            ]
        },
        {
            "resultDate": "06/24/2025",
            "results": [
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "35",
                     }
            ]
        },
        {
            "resultDate": "06/25/2025",
            "results": [
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "09",
                     }
            ]
        },
        {
            "resultDate": "06/26/2025",
            "results": [
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "75",
                     }
            ]
        },
        {
            "resultDate": "06/27/2025",
            "results": [
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "84",
                     }
            ]
        },
        {
            "resultDate": "06/28/2025",
            "results": [
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "31",
                     }
            ]
        },
        {
            "resultDate": "06/29/2025",
            "results": [
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "91",
                     }
            ]
        },
        {
            "resultDate": "06/30/2025",
            "results": [
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "53",
                     }
            ]
        },
        {
            "resultDate": "07/01/2025",
            "results": [
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "36",
                     }
            ]
        },
        {
            "resultDate": "07/02/2025",
            "results": [
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "25",
                     }
            ]
        },
        {
            "resultDate": "07/03/2025",
            "results": [
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "03",
                     }
            ]
        },
        {
            "resultDate": "07/04/2025",
            "results": [
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "90",
                     }
            ]
        },
        {
            "resultDate": "07/05/2025",
            "results": [
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "82",
                     }
            ]
        },
        {
            "resultDate": "07/06/2025",
            "results": [
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "32",
                     }
            ]
        },
       
    ]
  
